export default __webpack_public_path__ + "562b968b06fd69e4687f761b6b2f2878.svg";